import { render, staticRenderFns } from "./card2.vue?vue&type=template&id=b1182fb4&scoped=true&"
import script from "./card2.vue?vue&type=script&lang=js&"
export * from "./card2.vue?vue&type=script&lang=js&"
import style0 from "./card2.vue?vue&type=style&index=0&id=b1182fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1182fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1182fb4')) {
      api.createRecord('b1182fb4', component.options)
    } else {
      api.reload('b1182fb4', component.options)
    }
    module.hot.accept("./card2.vue?vue&type=template&id=b1182fb4&scoped=true&", function () {
      api.rerender('b1182fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/components/cards/card2.vue"
export default component.exports